import React from 'react'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import * as yup from 'yup'

import { useForm } from 'src/forms'
import { setApiErrors } from 'src/forms/errors'
import { skuit } from 'src/services/skuit'
import { Market } from 'src/api/models'
import { AxiosError } from 'axios'
import { handleErrorMessage, Notification } from 'src/components/Notification'
import toast from 'react-hot-toast'

const useStyles = makeStyles(() => ({
  form: {
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
}))

interface MarketProps {
  name: string
}

const marketSchema = yup.object().shape({
  name: yup.string().label('Name').required(),
})

interface Props {
  open: boolean
  handleClose: () => void
  onSave?: () => void
  update?: boolean
  market?: Market
}

export const MarketDialog = (props: Props) => {
  const { open, handleClose, onSave, update, market } = props
  const classes = useStyles()

  const onSubmit = (data: MarketProps) => {
    let func = skuit.sc.markets.create
    let action = 'creat'
    if (update) {
      func = (data: MarketProps) => skuit.sc.markets.patch(market?.guid || '', data)
      action = 'updat'
    }
    func(data)
      .then((newMarket: Market) => {
        handleClose()
        if (onSave) {
          onSave()
        }
        toast.success(
          <Notification
            message={`Successfully ${action}ed Market: ${newMarket.name}`}
            newObject={newMarket}
          />
        )
      })
      .catch((error: AxiosError) => {
        handleErrorMessage(error, action, 'Market')
        setApiErrors(formData.setError, error)
      })
  }

  const { Form, Field, data: formData } = useForm(marketSchema)

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <Form formProps={{ className: classes.form }} onSubmit={onSubmit}>
        <DialogTitle>Create Market</DialogTitle>
        <DialogContent>
          <Field
            name="name"
            defaultValue={market?.name}
            renderField={({ name, value, setValue, error }) => (
              <TextField
                id={name}
                name={name}
                label="Name"
                error={!!error}
                helperText={error}
                fullWidth
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setValue(name, e.target.value)
                }
                value={value || ''}
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button type="submit" color="primary" variant="contained" autoFocus>
            Save
          </Button>
        </DialogActions>
      </Form>
    </Dialog>
  )
}
